var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import RequestHandler from './RequestHandler';
var UserAgentHelper = /** @class */ (function (_super) {
    __extends(UserAgentHelper, _super);
    function UserAgentHelper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserAgentHelper.getUserAgent = function () {
        var _a;
        if (this.getServerAgent() && typeof this.getServerAgent() !== 'undefined' && this.getServerAgent() !== '') {
            return this.getServerAgent() || '';
        }
        return (typeof window !== 'undefined' && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent)) || '';
    };
    return UserAgentHelper;
}(RequestHandler));
export default UserAgentHelper;
